// @ts-expect-error - Automatic, Please fix when editing this file
const selectNeedsType = (state, props) => props?.match?.params?.needsType ?? null;

export default selectNeedsType;
